import type { SVGProps } from 'react'
const IconChevronDownSm = (props: SVGProps<SVGSVGElement>) =>  
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" { ...props} >
    <path id="Vector 111" d="M1 0.882812L5 4.88281L9 0.882812" stroke="#142546" strokeWidth="1.57" />
  </svg>

export default IconChevronDownSm

